import { Button, Form, Input, Modal } from 'antd';
import { jwtDecode } from 'jwt-decode';
import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import apiClient from '../../apis/ApiInterceptor';
import { getFeaturesForUser } from '../../apis/featureApi';
import { fetchUser } from '../../apis/usersApi';
import { useAuth } from '../../components/AuthProvider';
import { openNotification } from '../../components/notifications';
import { loadGlobalConfig } from '../../config';
import { forgotPassword } from '../../apis/authApi';

const LoginForm = () => {
  const [loading, setLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [resetLoading, setResetLoading] = useState(false);
  const [resetEmail, setResetEmail] = useState("");

  const navigate = useNavigate();
  const location = useLocation();
  const redirectTo = location.state?.from?.pathname || null;
  const { updateAuthentication } = useAuth();

  const onFinish = async (values) => {
    setLoading(true);
    try {
      // TODO: move to authApi.js
      const response = await apiClient.post('/auth/login', values);
      if (response.status === 200) {
        const access_token = response.data.access_token;
        localStorage.setItem('access_token', access_token);
        localStorage.setItem('refresh_token', response.data.refresh_token);
        const decodedToken = jwtDecode(access_token);
        const userId = decodedToken.sub;
        const user = await fetchUser(userId);
        localStorage.setItem('branch_id', user.default_branch_id);

        // Get User features
        const userFeatures = await getFeaturesForUser(user.default_branch_id, userId);
        localStorage.setItem('user_features', JSON.stringify(userFeatures));

        // Refresh branch config
        await loadGlobalConfig();
        
        // Update global authentication state
        updateAuthentication(true, userId);

        if (redirectTo) {
          navigate(redirectTo, { replace: true });
        } else {
          navigate('/home', { replace: true });
        }
      }
    } catch (error) {
      openNotification(
        "error",
        "Error de autenticación",
        error.response?.data.message
      );
    } finally {
      setLoading(false);
    }
  };

  const handlePasswordReset = async () => {
    if (!resetEmail) {
      openNotification("warning", "Campo requerido", "Por favor ingresa tu correo.");
      return;
    }
    setResetLoading(true);
    try {
      await forgotPassword(resetEmail);
      openNotification("success", "Solicitud enviada", "Revisa tu correo para continuar con el proceso de recuperación.");
      setModalVisible(false);
      setResetEmail("");
    } catch (error) {
      openNotification(
        "error",
        "Error",
        error.response?.data?.message || "No pudimos enviar la solicitud."
      );
    } finally {
      setResetLoading(false);
    }
  };

  return (
    <>
      <Form className='p-5' style={{ minHeight: "80vh" }} onFinish={onFinish}>
        <Form.Item name="email" rules={[{ required: true, message: 'Por favor ingresa tu email' }]}>
          <Input placeholder="Email" />
        </Form.Item>
        <Form.Item name="password" rules={[{ required: true, message: 'Por favor ingresa tu contraseña' }]}>
          <Input.Password placeholder="Contraseña" />
        </Form.Item>

        {/* Forgot password link */}
        <div className='mb-3'>
          <Button type="link" onClick={() => setModalVisible(true)}>
            ¿Olvidaste tu contraseña?
          </Button>
        </div>

        <div className='d-flex'>
          <Button
            className='btn themed-btn ml-auto'
            type="primary"
            htmlType="submit"
            loading={loading}
          >
            Iniciar sesión
          </Button>
        </div>
      </Form>

      {/* Password Reset Modal */}
      <Modal
        title="Recuperar contraseña"
        open={modalVisible}
        onCancel={() => setModalVisible(false)}
        footer={[
          <Button key="cancel" onClick={() => setModalVisible(false)}>
            Cancelar
          </Button>,
          <Button
            key="submit"
            type="primary"
            loading={resetLoading}
            onClick={handlePasswordReset}
          >
            Enviar
          </Button>
        ]}
      >
        <p>Ingresa tu correo electrónico para recuperar tu contraseña:</p>
        <Input
          value={resetEmail}
          onChange={(e) => setResetEmail(e.target.value)}
          placeholder="Correo electrónico"
        />
      </Modal>
    </>
  );
};

export default LoginForm;
